export default __webpack_public_path__ + "static/media/gusto.44ad961c.svg";